export const expensesCategories: { [key: string]: string } = {
  facility_use_fee: 'Facility Use Fee',
  on_site_helper_pay: 'On Site Helper Pay',
  cleaning_repair_fee: 'Cleaning Repair Fee',
  craft_or_supply_costs_for_students: 'Craft or Supply Costs for Students',
  adjustment: 'Adjustment',
  state_tax: 'State Tax',
  general_location_expense: 'General Location Expense'
};

export const expensesCategoriesOptions = [
  { id: 'facility_use_fee', label: 'Facility Use Fee' },
  { id: 'on_site_helper_pay', label: 'On Site Helper Pay' },
  { id: 'cleaning_repair_fee', label: 'Cleaning Repair Fee' },
  { id: 'craft_or_supply_costs_for_students', label: 'Craft or Supply Costs for Students' },
  { id: 'adjustment', label: 'Adjustment' },
  { id: 'state_tax', label: 'State Tax' }
  // { id: 'general_location_expense', label: 'General Location Expense' }
];

export const paymentMethods: { [key: string]: string } = {
  check: 'Check',
  credit_card: 'Credit Card',
  ach: 'ACH',
  inventory: 'Inventory'
};
export const paymentMethodOptions = [
  { id: 'check', label: 'Check' },
  { id: 'credit_card', label: 'Credit Card' },
  { id: 'inventory', label: 'Inventory' },
  { id: 'ach', label: 'ACH' }
];

export const paymentMethodNumbers: { [key: number]: string } = {
  1: 'Check',
  2: 'Credit Card',
  3: 'ACH',
  4: 'Inventory'
};

export const receiptStatuses: { [key: number]: string } = {
  0: 'pending',
  1: 'denied',
  2: 'approved'
};

export const expensesContext: { [key: string]: string } = {
  per_session: 'Per Session',
  per_class: 'Per Class'
};
export const expensesContextOptions = [
  { id: 'per_session', label: 'Per Session' },
  { id: 'per_class', label: 'Per Class' }
];

export const invoiceStatusColors: { [key: string]: string } = {
  draft: '#7F9BB4',
  sent: '#953E6A',
  late: '#CE4D2D',
  paid: '#BFC662'
};
